import { Variant } from "@mui/material/styles/createTypography";
import { IComponent } from "./IComponent";
import { IExpression } from "@@expressions";
import { PropertyDisplayFormat } from "./PropertyDisplayFormat";

export type TypographyModel = IComponent & {
  Variant?: Variant;
  Text?: string;
  Color?: string;
  BackgroundColor?: string;
  IconName?: string;
  IconPlacement?: IconPlacement;
  IconColor?: string;
  Value?: IExpression;
  Format?: PropertyDisplayFormat;
  Visible?: IExpression;
};

export enum IconPlacement {
  Start = "Start",
  End = "End",
}
